import Constants from '../../../app/utils/constants'
import { BlogCardGrid } from '../../atoms/BlogCard/BlogCard'
import { PortfolioCardRow } from '../../atoms/PortfolioCard/PortfolioCard'
import Testimonial from '../Testimonial/Testimonial'
import TitleHeader from '../../atoms/TitleHeader/TitleHeader'
import { motion, Variants } from 'framer-motion'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const Portfolio = () => {
  const { portfolioData, blogData } = Constants

  const [activePortfolioCard, setActivePortfolioCard] = useState(0)

  const navigate = useNavigate()

  /* 🔥 reusable animation */
  const sectionVariant: Variants = {
    hidden: { opacity: 0, y: 60 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: 'easeIn',
        staggerChildren: 0.15,
      },
    },
  }

  return (
    <div className="text-white mt-15">

      {/* ================= FIRST SECTION ================= */}
      <motion.div
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, margin: '-100px' }}
      >

        {/* WRAPPER */}
        <div className="relative mb-10">

          {/* CENTER TITLE */}
          <div className="flex justify-center items-center">
            <TitleHeader
              badgeText="PORTFOLIO"
              titleLines={['Explore Our Recent Projects']}
              wrapperClassName="w-full max-w-3xl flex flex-col items-center text-center"
              titleClassName="text-4xl md:text-4xl font-rajdhani font-semibold text-center"
              badgeClassName="text-lg md:text-2xl px-10 md:px-12 py-3 md:py-4"
            />
          </div>

        </div>

        {/* CARDS */}
        <motion.div variants={sectionVariant}>
          <PortfolioCardRow items={portfolioData} />
        </motion.div>

      </motion.div>

      {/* ================= SECOND SECTION ================= */}
      {/*
      <motion.div
        className="mt-20"
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, margin: '-100px' }}
      >
        <div className="flex justify-center items-center mt-15 mb-10">
          <TitleHeader
            badgeText="BLOG"
            titleLines={['Explore Our Recent Blogs']}
            wrapperClassName="w-full max-w-3xl flex flex-col items-center text-center"
            titleClassName="text-4xl md:text-6xl font-rajdhani font-semibold text-center"
            badgeClassName="text-2xl md:text-3xl px-10 md:px-12 py-3 md:py-4"
          />
        </div>

        <motion.div variants={sectionVariant}>
          <BlogCardGrid
            items={blogData}
            navigateTo="/blogpage"
          />
        </motion.div>
      </motion.div>
      */}

      {/* ================= THIRD SECTION ================= */}
      <motion.div
        className="mt-20"
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, margin: '-100px' }}
      >
        <Testimonial className="mx-auto mb-20 max-w-[90%]" />
      </motion.div>

    </div>
  )
}

export default Portfolio